import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';


/* global customElements */
class CityXRefGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var cityGrid = this;
		setTimeout(function(){
			cityGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var cityGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (cityGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',			
					postinit: function(combo) {
						if (cityGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {						
							actionRefresh();
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'cityName',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'cityName',
								description: 'City Name'								
							},
							{
								code: 'replaceCity',
								description: 'Replace City'	
							},
							{
								code: 'stateProvCode',
								description: 'State'	
							},
							{
								code: 'countryCode',
								description: 'Country'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				}
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_CITY_X_REFERENCES:WRITE', 'CITY_X_REFERENCE_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_CITY_X_REFERENCES:WRITE', 'CITY_X_REFERENCE_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_CITY_X_REFERENCES:WRITE', 'CITY_X_REFERENCE_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_CITY_X_REFERENCES:DELETE', 'CITY_X_REFERENCE_MANAGEMENT:DELETE'],
							'class': 'spacer-toolbar-item',	
							style: 'width: 200px;',
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							properties: {
								menu: [
									{
										tag: 'vaadin-item',
										itemid: 'deleteOne',
										disabled: true,
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:minus-circle-o"></vaadin-icon> Remove Selected',
										listeners: {
											click: function(event) {
												actionDelete(grid.selectedItems);
											}
										}
									},
									{
										tag: 'span',
										trustedInnerHTML: true,
										innerHTML: '<hr>'
									},
									{
										tag: 'vaadin-item',									
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:minus-circle"></vaadin-icon> Remove All',
										listeners: {
											click: function(event) {
												actionDeleteAll();
											}
										}
									}
								]
							}
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'cityName',
					header: 'City Name',
					width: '7em'
				},	
				{						
					path: 'replaceCity',
					header: 'Replace City',
					width: '7em'
				},
				{						
					path: 'stateProvCode',
					header: 'State/Province',
					width: '7em'
				},
				{						
					path: 'countryCode',
					header: 'Country Code',
					width: '7em'
				},
				{						
					path: 'latitude',
					header: 'Latitude',
					width: '7em'
				},
				{						
					path: 'longitude',
					header: 'Longitude',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				var deleteBtn = ElementUtil.query(toolbar, 'delete');
				if (grid.selectedItems.length > 0) {					
					ElementUtil.query(toolbar, 'edit').disabled = true;
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
					}
					if (ElementUtil.query(deleteBtn, 'deleteOne')) {
						ElementUtil.query(deleteBtn, 'deleteOne').disabled = false; 						
					}
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;
					if (ElementUtil.query(deleteBtn, 'deleteOne')) {
						ElementUtil.query(deleteBtn, 'deleteOne').disabled = true; 						
					}
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
						
						if (cityGrid.admin) {
							var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							if (selectedCompany) {
								grid.currentFilter.companyId = selectedCompany;
							}							
						}
												
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						RoutingService.getCityXReferenceService().getCityXRefs(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		cityGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(cityGrid, toolbarFilter, ['filterCompany','filterType','filterValue'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{										
											tag: 'vaadin-combo-box',
											itemid: 'country',											
											'keep-open': true,															
											label: 'Country',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'countryCode',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('CountryCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select',
											listeners: {
												change: function() {
													var countyCB = ElementUtil.query(formPanel, 'country');
													var stateCB = ElementUtil.query(formPanel, 'state');
													Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
														if (countyCB.value) {
															var filtered = [];														
															data.forEach(function(item){
																if (item.country === countyCB.value) {
																	filtered.push(item);
																}
															});
															stateCB.items = filtered;
														} else {
															stateCB.items = [];
														}
													});
												} 
											}
										},
										{										
											tag: 'vaadin-combo-box',
											itemid: 'state',											
											'keep-open': true,															
											label: 'State/Prov',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'stateProvCode',
											required: true,
											postinit: function(combo) {												
											},
											placeHolder: 'Select'					
										},	
										{
											tag: 'vaadin-text-field',
											itemid: 'cityName',	
											name: 'cityName',
											label: 'City',
											required: true,
											maxLength: 255											
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'replaceCity',
											'allow-custom-value': true,
											'keep-open': true,															
											label: 'Replace City',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'replaceCity',
											required: true,
											postinit: function(combo) {												
											},
											placeHolder: 'Select',
											listeners: {
												'value-changed':  {
													fn: function() {
														var replaceCityCB = ElementUtil.query(formPanel, 'replaceCity');
														
														if (replaceCityCB.value.length > 3) {
															//load suggestions
															var paging = {
																distinctCity: true,
																filterField: 'postalCodeCityId.cityName',
																filterValue: replaceCityCB.value,
																max: 100,
																sortField: 'postalCodeCityId.cityName'
															};
															RoutingService.getPostalCodeService().getPostalCodes(paging).then(function(result){
																var lookups = [];
																result.data.forEach(function(item){
																	lookups.push({
																		code: item.postalCodeCityId.cityName,
																		description: item.postalCodeCityId.cityName
																	});																
																});
																
																replaceCityCB.items = lookups;
															});
															
														}
													},
													buffer: 500
												} 
											}										
										},									
										{
											tag: 'vaadin-number-field',
											name: 'latitude',
											label: 'Latitude'
										},
										{
											tag: 'vaadin-number-field',
											name: 'longitude',
											label: 'Longitude'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {																	
																	return data;
																},
																actualCall: function(data) {
																	if (record) {
																		data.cityXrefId = record.cityXrefId;
																	}
																	if (cityGrid.admin) {
																		var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
																		if (companyId) {
																			data.companyId = companyId;
																		}
																	}
																	
																	return RoutingService.getCityXReferenceService().saveCityXRef(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved City X Reference', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);
							
							var event = new Event('change');
							ElementUtil.query(formPanel, 'country').dispatchEvent(event);
						}
					}
				}
			});			
		};
		
		var actionDelete = function(records) {
	
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.cityXrefId);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected city x references(s)?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							RoutingService.getCityXReferenceService().deleteCityXReferences(requestModel)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});

					
		};	
		
		var actionDeleteAll = function() {

			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ALL references? <b>It recommendated do an export before this.</b>',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');
							
							var companyId;
							if (cityGrid.admin) {
								companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;								
							}

							RoutingService.getCityXReferenceService().deleteAllCityXReferences(companyId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};
		
		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Reference File',
				icon: 'vaadin:upload',
				width: 450,
				height: 230,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A reference import file is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/cityxrefs/import',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-request': function(event) {
												//var data = uploadFormPanel.getData();	
												
												if (cityGrid.admin) {
													var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;								
													event.detail.formData.append('companyId', companyId);
												}												
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});					
			
		};
		
		var actionExport = function() {
			var exportFilter = Object.assign({}, grid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			RoutingService.getCityXReferenceService().exportCityXReferences(exportFilter);
		};
		
	}
	
}
customElements.define('dl-cityxref-grid', CityXRefGrid);


